import React, { useEffect, useState, FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import propTypes from "prop-types";

import { api, Booking, IComplaintsList, IInspectionList, Inspection } from "../../../logic/api";

import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";

import { useDate } from "../../../utility/useDate";

import { BookingInspection } from "../BookingInspection/BookingInspection";
import { useTranslation } from "react-i18next";

export const BookingInspections: FC<{ booking: Booking, show: boolean, onHide: () => void }> = (props) => {
    const { toFormattedDateTimeString } = useDate();
    const [inspectionParams, setInspectionsParams] = useState<IInspectionList>({ bookingId: props.booking.id });
    const [showInspection, setShowInspection] = useState(false);
    const [inspection, setInspection] = useState<Inspection | null>(null);

    const { t } = useTranslation();

    useEffect(() => {
        setInspectionsParams({ ...inspectionParams, bookingId: props.booking.id });
    }, [props.booking.id]);

    return <Dialog open={props.show} fullWidth={true} maxWidth="sm"  >
        <DialogTitle>
            {t("booking.labels.vehicleInspections")}
        </DialogTitle>
        <DialogContent>
            {inspection != null && (
                <BookingInspection inspection={inspection} show={showInspection} onHide={(saved) => {
                    setShowInspection(false);

                    if (saved) {
                        setInspectionsParams({ ...inspectionParams });
                    }
                }}></BookingInspection>
            )}

            <PagedDataView<IComplaintsList, Inspection>
                apiHook={api.hooks.inspection.list}
                parameters={inspectionParams}
                renderItem={(item) => {

                    return <div
                        style={{ padding: 10, border: "solid 1px #eee", borderRadius: 7, marginBottom: "10px", cursor: "pointer" }}
                        onClick={() => {
                            setInspection({ ...item, booking: props.booking });
                            setShowInspection(true);
                        }}
                    >
                        <div><b>{t("booking.labels.inspection")}</b></div>
                        <div>{toFormattedDateTimeString(new Date(item.inspectionDate))}</div>
                    </div>
                }}
            >
                {t("input.validations.noInspection")}
            </PagedDataView>
        </DialogContent>
        <DialogActions>

            <Button onClick={() => props.onHide()} color="secondary">
                {t("general.done")}
            </Button>
        </DialogActions>
    </Dialog>
};

BookingInspections.propTypes = {
    booking: propTypes.any.isRequired,
    show: propTypes.bool.isRequired,
    onHide: propTypes.any.isRequired
};